export default __webpack_public_path__ + "static/media/beta-landing-asset-2.d4539f8f.svg";